<template>
  <a-modal
    title="下载淘宝订单"
    :width="640"
    :visible="visible"
    :confirmLoading="confirmLoading"
    okText="开始下载"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item style="display: none" label="平台" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <input v-decorator="['platform', { initialValue: '1' }]" />
        </a-form-item>
        <!-- <a-form-item label="订单来源" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select
            v-decorator="['source', { initialValue: '1' }]"
            placeholder="请选择"
            @change="form.setFieldsValue({ status: '1' })"
          >
            <a-select-option value="1">淘宝订单</a-select-option>
            <a-select-option value="2" disabled>三方订单</a-select-option>
            <a-select-option value="3" disabled>维权订单</a-select-option>
          </a-select>
        </a-form-item> -->
        <a-form-item label="订单状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select
            v-decorator="['status', { initialValue: '2', rules: [{ validator: this.handleStatusCheck }] }]"
            placeholder="请选择"
          >
            <a-select-option value="1">订单创建</a-select-option>
            <a-select-option value="2">订单付款</a-select-option>
            <a-select-option value="3">订单结算</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="开始时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-date-picker
            style="width: 100%"
            :format="dateFormat"
            showTime
            :disabledDate="disabledStartDate"
            v-decorator="[
              'start_time',
              { initialValue: moment().startOf('day'), rules: [{ required: true, message: '必填项' }] },
            ]"
            placeholder="开始时间"
            @openChange="handleStartOpenChange"
          />
        </a-form-item>
        <a-form-item label="结束时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-date-picker
            style="width: 100%"
            :format="dateFormat"
            showTime
            :disabledDate="disabledEndDate"
            v-decorator="[
              'end_time',
              {
                initialValue: moment(),
                rules: [{ required: true, message: '必填项' }, { validator: this.handleEndTimeCheck }],
              },
            ]"
            placeholder="结束时间"
            :open="endOpen"
            @openChange="handleEndOpenChange"
          />
        </a-form-item>
        <!-- <a-form-item label="快捷选择" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-button type="dashed" @click="quickDate({ day: 7 })">近7天</a-button>
          <a-divider type="vertical" />
          <a-button type="dashed" @click="quickDate({ day: 15 })">近15天</a-button>
          <a-divider type="vertical" />
          <a-button type="dashed" @click="quickDate({ day: 30 })">近30天</a-button>
        </a-form-item> -->
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import moment from 'moment'
import 'moment/locale/zh-cn'
import { ORDER_SYNC_TB } from '@/store/mutation-types'
moment.locale('zh-cn')
import { mapActions, mapGetters } from 'vuex'
export default {
  data() {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 },
      },
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      robotid: '',
      dateFormat: 'YYYY-MM-DD HH:mm:ss',
      rangeTime: null,
      endOpen: false,
    }
  },
  methods: {
    moment,
    ...mapActions(['WEBSOCKER_ACTIONS_SENDROBOTMSG', 'updateOrderDownloadStatus']),
    show(robotid) {
      this.robotid = robotid
      this.visible = true
    },
    // 结束时间检验
    handleEndTimeCheck(rule, value, callback) {
      if (value.unix() > moment().unix()) {
        callback(new Error('结束时间不能超过当前时间'))
      }
      callback()
    },
    handleSubmit() {
      const {
        form: { validateFields },
      } = this
      validateFields((errors, values) => {
        if (!errors) {
          this.confirmLoading = true
          const data = {
            platform: values.platform,
            source: values.source,
            status: values.status,
            start_time: moment(values.start_time).unix(),
            end_time: moment(values.end_time).unix(),
          }
          this.$ls.set(ORDER_SYNC_TB, +moment(), 60 * 60 * 1000)
          this.WEBSOCKER_ACTIONS_SENDROBOTMSG({
            robotid: this.robotid,
            type: 'getorder',
            data: data,
          })
            .then((result) => {
              this.visible = false
              this.confirmLoading = false
              this.$emit('ok', values)
            })
            .finally(() => {
              this.confirmLoading = false
            })
          this.updateOrderDownloadStatus({
            sub_id: this.robotid,
            data: {
              order_type: 'taobao',
              atpresent: 0,
            },
          })
        }
      })
    },
    handleCancel() {
      this.visible = false
    },
    disabledDate(current) {
      return current && (current < moment().subtract(90, 'days').startOf() || current > moment())
    },
    disabledStartDate(start_value) {
      if (start_value.unix() < moment().subtract(30, 'days').unix() || start_value.unix() > moment().unix()) {
        return true
      }
      const startValue = start_value.unix()
      const endValue = moment(this.form.getFieldValue('end_time')).unix()
      if (!startValue || !endValue) {
        return false
      }
      return startValue > endValue
    },
    disabledEndDate(end_value) {
      if (end_value.unix() < moment().subtract(30, 'days').unix() || end_value.unix() > moment().unix()) {
        return true
      }
      const endValue = end_value.unix()
      const startValue = moment(this.form.getFieldValue('start_time')).unix()
      if (!endValue || !startValue) {
        return false
      }
      return startValue >= endValue
    },
    handleStartOpenChange(open) {
      if (!open) {
        this.endOpen = true
      }
    },
    handleEndOpenChange(open) {
      this.endOpen = open
    },
    quickDate({ day }) {
      this.form.setFieldsValue({
        start_time: moment().subtract(day, 'days').startOf('day'),
        end_time: moment(),
      })
    },
    handleStatusCheck(rule, value, callback) {
      const source = this.form.getFieldValue('source')
      // if (source != '1' && value != '1') {
      //   callback(new Error('非淘宝订单时请选择"全部状态"'))
      // }
      callback()
    },
  },
}
</script>
